module.exports = __webpack_public_path__ + "img/lg_ring_r_l_1_null@3x.4e9250da.png";